import styles from './Footer.module.css';

const Footer = () => {
  return <footer className={styles.footer}>Amazon Confidential</footer>;
};

export { Footer };
